import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { ProfileComponent } from '../components/profile/profile-component';
import { Address } from '../components/profile-form/address';
import { BirthInfo } from '../components/profile-form/birth-info';
import { Race } from '../components/profile-form/race';
import { UserInfo } from '../components/profile-form/user-info';
import { IdentityContext, UserIdentityProvider } from '../context';
import { useIndex } from '../hooks';

export function ProfilePage() {
  return (
    <UserIdentityProvider>
      <ProfileProxy />
    </UserIdentityProvider>
  );
}

export function ProfileProxy() {
  const { person } = useContext(IdentityContext);

  if (!person) {
    return (
      <div>
        <h1>Profile</h1>
        <p>Your profile has not been filled out yet.</p>
        <Link to="/profiles/new">Get started!</Link>
      </div>
    );
  }

  return (
    <AddressProvider>
      <ProfileComponent />
    </AddressProvider>
  );
}

interface ProfileFormProps {
  create: boolean;
  handleSave?: () => void;
}

export function PersonalInfoForm({ handleSave }: ProfileFormProps) {
  const location = useLocation();

  let component = null;

  if (location.hash === '#user-info' || !location.hash) {
    component = <UserInfo />;
  } else if (location.hash === '#address') {
    component = <Address />;
  } else if (location.hash === '#birth-info') {
    component = <BirthInfo />;
  } else if (location.hash === '#race') {
    component = <Race customHandleSave={handleSave} />;
  }

  // TODO: hide bottom nav
  return (
    <UserIdentityProvider>
      <div className="profile-form">
        {component}
      </div>
    </UserIdentityProvider>
  );
}

export const AddressContext = React.createContext(null);

export function AddressProvider({ children }) {
  const { person } = useContext(IdentityContext);
  const { data, loading: addressLoading } = useIndex(
    'addresses',
    { person_id: person.id },
    !person
  );

  if (addressLoading) {
    return <div>Loading address...</div>;
  }

  return (
    <AddressContext.Provider value={{ address: data[0] ?? {} }}>{children}</AddressContext.Provider>
  );
}

export function assessProfile(profile) {
  const { first_name: firstName, last_name: lastName } = profile;

  return firstName && lastName;
}
